/**
 * SupplierContactService
 * Service for Supplier Contact entity operations
 * Route: api/suppliercontacts
 */
import { CrudService } from '../base/CrudService';
/**
 * SupplierContactService
 * Handles supplier contact CRUD operations
 */
export class SupplierContactService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SupplierContactService.DEFAULT_SERVICE_PATH,
            basePath: SupplierContactService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Get contacts by supplier ID
     * @param supplierId - Supplier ID
     * @returns Array of contacts for the supplier
     */
    async getBySupplier(supplierId) {
        const response = await this.getBySupplierRaw(supplierId);
        return response.data ?? [];
    }
    /**
     * Get contacts by supplier ID (raw)
     * @param supplierId - Supplier ID
     * @returns ResponseData with contacts
     */
    getBySupplierRaw(supplierId) {
        const endpoint = this.getEndpoint('by-supplier', `by-supplier/${supplierId}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
}
SupplierContactService.DEFAULT_SERVICE_PATH = 'suppliers';
SupplierContactService.BASE_PATH = 'api/suppliercontacts';
//# sourceMappingURL=SupplierContactService.js.map